import React from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {useSelector} from 'react-redux';
import {AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY} from 'configs/AppConfig'

const ProtectedRoute = () => {

    const {token} = useSelector(state => state.auth)

    if (!token) {
        return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}`}/>;
    }

    return <Outlet/>
}

export default ProtectedRoute